import {getGroupItemsMarkup} from "../../js/utils/markup/get-group-item-markup";
import AbstractComponent from "./abstract-component";

const createTemplate = (className, title, items) => {
  const itemsMarkup = getGroupItemsMarkup(items);
  return (
    `<section class="${className}__accessory accessory">
      <div class="accessory__wrap container">
        <h2 class="accessory__title">${title}</h2>

        <ul class="group-page__groupList">
          ${itemsMarkup}
        </ul>
      </div>
    </section>`
  );
};

export default class AccessoryListComponent extends AbstractComponent {
  constructor({className, title = ``, items = ``}) {
    super();

    this._className = className;
    this._title = title;
    this._items = items;
  }

  getTemplate() {
    return createTemplate(this._className, this._title, this._items);
  }
}
